var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmptyStreams = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 153,
  height: 153,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 153,
  height: 153,
  fill: "#E7EAED",
  rx: 76.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#CED4DA",
  fillRule: "evenodd",
  stroke: "#CED4DA",
  strokeWidth: 4,
  d: "M39 49.814A2.814 2.814 0 0 1 41.814 47h70.003a2.814 2.814 0 0 1 2.814 2.814v44.793a2.814 2.814 0 0 1-2.814 2.814H41.814A2.814 2.814 0 0 1 39 94.607z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#CED4DA",
  strokeLinecap: "round",
  strokeWidth: 4,
  d: "M63.959 106.243h27.227"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.8,
  d: "M73 66.843a1 1 0 0 1 1.545-.839l7.165 4.658a1 1 0 0 1 0 1.676l-7.165 4.658A1 1 0 0 1 73 76.157z"
})));
export { SvgEmptyStreams as ReactComponent };
export default __webpack_public_path__ + "static/media/emptyStreams.e6c6877b.svg";